(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jiuss_index_slide"] && !Shopify.designMode) return;
  try {
    
$(function(){
$(".jiussindexslideleft ul li").each(function(i){$(this).hover(function(){$(this).addClass("jiusson").siblings().removeClass("jiusson");$(".jiussindexslidecontent:eq("+i+")").show().siblings(".jiussindexslidecontent").hide();});});
});

  } catch(e) { console.error(e); }
})();
})();
